import React from 'react'
import { BaseDialog } from './base-dialog'
import { Column, Expaned, Row } from '../layout/layout'
import { Styles } from 'jss'
import { InkWell } from '../inkwell/inkwell'
import './modal.scss'
import { getBEMCls } from '@/utils/classname'
import classNames from 'classnames'

export interface ModelType {
    isShow: boolean
    title?: string
    onClose?: () => void
    disabled?: boolean
    style?: Styles
    width?: number
    type: 'danger' | 'success'
    onCancel?: () => void
    onConfirm?: () => void
    loading?: boolean
    cancelText?: string
    showCancel?: boolean
    cancelStyles?: Styles
    okText?: string
    okStyles?: Styles
    headerStyles?: Styles
    footer?: React.ReactNode
}

export const Modal: React.FC<ModelType> = props => {
    const cls = (...args: string[]) => getBEMCls('modal', ...args)

    return (
        <BaseDialog
            width={props.width}
            title={props.title}
            styles={props.headerStyles}
            onClose={props.onClose}
            isShow={props.isShow}
        >
            <Column style={{ ...props.style, padding: '16px' }}>
                <Expaned>{props.children}</Expaned>
                {props.footer !== undefined ? (
                    props.footer
                ) : (
                    <Row className={cls('footer')}>
                        {props.showCancel && (
                            <InkWell className={cls('borderRadius')} onClick={() => props.onCancel && props.onCancel()}>
                                <div
                                    data-cursor-pointer
                                    style={{ ...props.cancelStyles }}
                                    className={classNames(cls('button'), cls('cancel'))}
                                >
                                    {props.cancelText || '取消'}
                                </div>
                            </InkWell>
                        )}
                        <InkWell
                            className={cls('borderRadius')}
                            data-margin-left-10
                            onClick={e => {
                                if (props.disabled || props.loading) return
                                props.onConfirm && props.onConfirm()
                            }}
                        >
                            <div
                                data-cursor-pointer
                                style={{ ...props.okStyles }}
                                className={classNames(cls('button'), cls(props.type), {
                                    [cls('disabled')]: props.disabled,
                                    [cls('loading')]: props.loading,
                                })}
                            >
                                {props.loading && <div className={cls('rotate')} />}
                                {props.okText || '确定'}
                            </div>
                        </InkWell>
                    </Row>
                )}
            </Column>
        </BaseDialog>
    )
}

Modal.defaultProps = {
    showCancel: true,
    title: '提示',
}
